import * as types from './productActionTypes';

const initialState = {
  productList: [],
  productData: null,
  isLoading: false,
  error: null,
  addProductData: null,
  updateProductData: null,
  deleteProductData: null,
  productDetail: null,
  productDetailLoading: false,
  productDetailError: null,
  // Pagination
  totalCount: 0,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 0,
  hasPreviousPage: false,
  hasNextPage: false,
};

export const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PRODUCT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_PRODUCT_SUCCESS:
      return { 
        ...state, 
        isLoading: false, 
        productList: action.payload?.ProductList || [],
        totalCount: action.payload?.TotalCount || 0,
        pageNumber: action.payload?.PageNumber || 1,
        pageSize: action.payload?.PageSize || 10,
        totalPages: action.payload?.TotalPages || 0,
        hasPreviousPage: action.payload?.HasPreviousPage || false,
        hasNextPage: action.payload?.HasNextPage || false,
        error: null 
      };
    case types.GET_PRODUCT_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.ADD_PRODUCT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_PRODUCT_SUCCESS:
      return { ...state, isLoading: false, addProductData: action.payload, error: null };
    case types.ADD_PRODUCT_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.UPDATE_PRODUCT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_PRODUCT_SUCCESS:
      return { ...state, isLoading: false, updateProductData: action.payload, error: null };
    case types.UPDATE_PRODUCT_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.DELETE_PRODUCT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DELETE_PRODUCT_SUCCESS:
      return { ...state, isLoading: false, deleteProductData: action.payload, error: null };
    case types.DELETE_PRODUCT_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.GET_PRODUCT_DETAIL_REQUEST:
      return { ...state, productDetailLoading: true, productDetailError: null };
    case types.GET_PRODUCT_DETAIL_SUCCESS:
      return { ...state, productDetailLoading: false, productDetail: action.payload,
         productDetailError: null };
    case types.GET_PRODUCT_DETAIL_ERROR:
      return { ...state, productDetailLoading: false, productDetailError: action.payload };

    default:
      return state;
  }
}; 